/**
 * Device detection composable
 * Detects device type and capabilities based on user agent and browser features
 */

// Check for touch capability using various methods
// Note: Some properties are non-standard and may not exist in all browsers
const touchable = (
  ('ontouchstart' in window)
  || (navigator.MaxTouchPoints > 0)
  || (navigator.msMaxTouchPoints > 0)
)

const userAgent = navigator.userAgent.toLowerCase()

const isApple = userAgent.includes('mac os x')
const isAndroid = userAgent.includes('android')
const isIPad = userAgent.includes('ipad')
const isIPhone = userAgent.includes('iphone')

export const useDeviceDetect = () => {
  return {
    touchable,
    isApple,
    isAndroid,
    isIPad,
    isIPhone,
  }
}

